import { KitchenImplantation } from '@shared/models';

export const kitchenImplantationMock: KitchenImplantation = {
  type: 'En U',
  surface: '7,6 m2',
  shortRef: 'u',
};
